export const downloadFileCsv = (table, filename) => {
    var csv = [];
    var rows = document.querySelectorAll(`${table} tr`);

    for (var i = 0; i < rows.length; i++) {
        var row = [], cols = rows[i].querySelectorAll("td, th");

        for (var j = 0; j < cols.length; j++)
            row.push(cols[j].innerText);

        csv.push(row.join(","));
    }
    let blob = new Blob(['\ufeff' + csv], { type: 'application/csv' });
    let url = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();

}
